<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 ">
  <loading v-if="loadingState" />
  <div class="container pt-2">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div v-if="!showDelegateForm" class="row justify-content-center text-left">
      <div class="col-12 col-md-12">
        <h3 class="Regular text-left  h0 widthFull"><b>Gestione Cessioni </b></h3>
        <p class="pb-0 mb-0 text-left Bold">In questa sezione puoi gestire le cessioni delle tue Pratiche approvate e validate dopo il 04 ottobre 2021  </p>
      </div>
    </div>

    <div class="row ">
    <section v-if="!showDelegateForm" id="tabs">
      <div class="container">
        <h5 class="section-title h3"></h5>
        <div class="row pt-0">
          <div class="col-12 col-md-12">
            <nav>
              <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a :class="'nav-item nav-link  cblack customNItem ' + section1" v-on:click.prevent="setSection(1)" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-to-do" aria-selected="true">Pratiche in attesa di Cessione </a>
                <a :class="'nav-item nav-link  cblack customNItem ' + section2" v-on:click.prevent="setSection(2)" id="nav-poste-tab" data-toggle="tab" href="#nav-poste" role="tab" aria-controls="nav-in-work" aria-selected="false">Cessioni in corso </a>
                <a :class="'nav-item nav-link  cblack customNItem ' + section3" v-on:click.prevent="setSection(3)" id="nav-cdp-docs-tab" data-toggle="tab" href="#nav-cdp-docs" role="tab" aria-controls="nav-ended" aria-selected="false">Cessioni completate</a>
              </div>
            </nav>
            <div class="tab-content  pt-0 mt-0 p-0 vaillantCont" id="nav-tabContent">
              <div :class="'pt-0 mt-0 tab-pane fade ' + section11" id="nav-to-do" role="tabpanel" aria-labelledby="nav-home-tab">

                  <div class="col-md-12 center mb-3 center boxNt">
                    <practicesToDo v-if="section1 == ' active'" />
                  </div>

              </div>
              <div :class="'tab-pane fade ' + section22" id="nav-poste" role="tabpanel" aria-labelledby="nav-in-work">

                  <div class="col-md-12 center mb-3 center boxNt">
                    <practicesinWork v-if="section2 == ' active'" />
                  </div>

              </div>

              <div :class="'tab-pane fade ' + section33" id="nav-cdp-docs" role="nav-ended" aria-labelledby="nav-cdp-docs-tab">

                  <div class="col-md-12 center mb-3 center boxNt">
                    <practicesFinished v-if="section3 == ' active'" />
                  </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <div v-if="showDelegateForm" class="row justify-content-center text-left">
      <h3 class="Regular center h0 widthFull"><b>Delega intermediario</b></h3>
      <p class="pb-0 mb-0 Bold mb-5">Prima di procedere con cessioni abbiamo bisogno del tuo consenso  </p>

      <!-- DALEGATE KPMG TO OPARATE CF -->
      <delegaForm />


    </div>

    </div>
    </div>

  </div>

</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'
import {
  BadgerAccordion,
  BadgerAccordionItem
} from 'vue-badger-accordion'

import {
  VueSvgGauge
} from 'vue-svg-gauge'

import practicesToDo from './practicesToDo.vue'
import practicesinWork from './practicesinWork.vue'
import practicesFinished from './practicesFinished.vue'
import delegaForm from '../flowSettings/delegaForm.vue'

const moment = require('moment')

export default {
  name: 'Practics',
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
    practicesToDo,
    practicesinWork,
    practicesFinished,
    delegaForm
  },
  data() {
    return {
      token: '',
      section1: ' active',
      section11: ' show active',
      section2: ' ',
      section22: ' ',
      section3: ' ',
      section33: ' ',
      section4: ' ',
      section44: ' ',
      loadingState: false,
      loading: false,
      practices: {},

      moment: require('moment'),
      showDelegateForm: false,

    }
  },
  methods: {
    checkDelega(){
      console.log( 'CHECK IF PRESENT AUTORIZATION FOR ADVISOR => ' + this.getProfile.delegate_move_credits  )

      if( this.getProfile.delegate_move_credits == 0 || this.getProfile.delegate_move_credits == '0' ){
        this.showDelegateForm = true
      }else{
        this.showDelegateForm = false
      }

    },

    setSection(section) {

      console.log(section)

      this.section1 = ' '
      this.section11 = ' '
      this.section2 = ' '
      this.section22 = ' '
      this.section3 = ' '
      this.section33 = ' '
      this.section4 = ' '
      this.section44 = ' '

      if (section == 1) {
        this.section1 = ' active'
        this.section11 = ' show active'
      }
      if (section == 2) {
        this.section2 = ' active'
        this.section22 = ' show active'
      }
      if (section == 3) {
        this.section3 = ' active'
        this.section33 = ' show active'
      }
      if (section == 4) {
        this.section4 = ' active'
        this.section44 = ' show active'
      }

    },

    async getPractices() {

      //await this.checkBonusValues()
      /*
      var _vue = this

      _vue.totUserReceived = _vue.getProfile.total_bonus_received


      this.loadingState = true
      console.log(_vue.getProfile.userToken)
      var token = _vue.getProfile.userToken
      if (token) {
        await axios({
            url: process.env.ROOT_API + 'api/getPractices',
            method: 'POST',
            data: {
              type: 'all',
              user_token: token
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            _vue.practices = resp.data.practices

            console.log(_vue.practices)

            _vue.totCash = 0
            _vue.countPractices = 0
            _vue.countCashInst = 0
            _vue.countCashClient = 0

            // ERRORS
            _vue.countErrorPractice = 0
            _vue.totErrorCashClient = 0
            _vue.totErrorCashInst = 0
            // STEP 1
            _vue.countStep1Practice = 0
            _vue.totStep1CashClient = 0
            _vue.totStep1CashInst = 0
            // STEP 2
            _vue.countStep2Practice = 0
            _vue.totStep2CashClient = 0
            _vue.totStep2CashInst = 0
            // STEP 3
            _vue.countStep3Practice = 0
            _vue.totStep3CashClient = 0
            _vue.totStep3CashInst = 0
            // STEP 4
            _vue.countStep4Practice = 0
            _vue.totStep4CashClient = 0
            _vue.totStep4CashInst = 0

            // NEWWWWWW

            _vue.totAmountBefore10 = 0
            _vue.totAmountAfter10 = 0

            for (var x in _vue.practices) {

              if (_vue.practices[x].status != '10') {

                _vue.countPractices++
                _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2)
                //_vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2)


                // NEWWWWWW

                _vue.totAmountBefore10 = (parseFloat(_vue.totAmountBefore10) + parseFloat(_vue.practices[x].amount_before_10)).toFixed(2)
                _vue.totAmountAfter10 = ( parseFloat(_vue.totAmountAfter10) + parseFloat(_vue.practices[x].amount_after_10) ).toFixed(2)


                _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                console.log(1)
                if (_vue.practices[x].hasErrors == 'yes') {
                  console.log(22)
                  _vue.countErrorPractice = _vue.countErrorPractice + 1
                  _vue.totErrorCashClient = (parseFloat(_vue.countErrorPractice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totErrorCashInst = (parseFloat(_vue.totErrorCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }

                if (_vue.practices[x].status == '1') {
                  _vue.countStep1Practice = _vue.countStep1Practice + 1
                  _vue.totStep1CashClient = (parseFloat(_vue.countStep1Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep1CashInst = (parseFloat(_vue.totStep1CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }

                if (_vue.practices[x].status == '2') {
                  _vue.countStep2Practice = _vue.countStep2Practice + 1
                  _vue.totStep2CashClient = (parseFloat(_vue.countStep2Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep2CashInst = (parseFloat(_vue.totStep2CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }

                if (_vue.practices[x].status == '3') {
                  _vue.countStep3Practice = _vue.countStep3Practice + 1
                  _vue.totStep3CashClient = (parseFloat(_vue.countStep3Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep3CashInst = (parseFloat(_vue.totStep3CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }

                if (_vue.practices[x].status == '4') {
                  _vue.countStep4Practice = _vue.countStep4Practice + 1
                  _vue.totStep4CashClient = (parseFloat(_vue.countStep4Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2)
                  _vue.totStep4CashInst = (parseFloat(_vue.totStep4CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                }

              }

              if (_vue.practices[x].status == '10') {
                _vue.hasRemovedPractics = true
              }

              console.log(333)

            }

            _vue.totAmountAfter10 = ( parseFloat(_vue.totAmountAfter10)- parseFloat(_vue.totUserReceived) ).toFixed(2)

            this.totCash = parseFloat(this.totCash)
            if (this.totCash < 10000) {
              this.maxTotCash = 10000
              this.step = 1000
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000
              this.step = 10000
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000
              this.step = 100000
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000
              this.step = 1000000
            }
            _vue.practicesFiltred = _vue.practices

            console.log(4444)

            _vue.loadingState = false
          })
          .catch(resp => {
            console.log('errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor')
            _vue.presentPractices = false,
              _vue.loadingState = false
          })
      }*/
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    },

  },
  watch: {
    getProfile: function(val) {
      if (val) {
        console.log(val)
        this.getPractices()
        this.checkDelega()
      }
    },

  },
  created() {

  },
  mounted() {

    if (this.getProfile) {
      this.getPractices()
      this.checkDelega()
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    })

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>


<style>

.boxNt{

  border-top: 3px solid #00897e;

}

.customNItem{

  height: 60px!important;
  border: 1px solid grey!important;
  padding-top: 15px;
  font-size: 20px;
  background:white;
}

@media (min-width: 20px) and (max-width: 767px) {
  .seachMobButton {
    padding: 0 !important;
    height: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cessioni/index.vue